import React from 'react';

import { Center, Loader, Stack, Text } from '@mantine/core';

interface LoadingStateProps {
  message?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading...',
  className,
  style
}) => {
  return (
    <Center className={className} style={style}>
      <Stack align="center" gap="md">
        <Loader size="xl" type="dots" />
        <Text c="dimmed" size="lg" ta="center">
          {message}
        </Text>
      </Stack>
    </Center>
  );
};

export default LoadingState;
